import React from 'react';
import { ApiClient, ApiProvider } from 'jsonapi-react';
import { deserialise as deserialize } from 'kitsu-core';

// docs: https://github.com/aribouius/jsonapi-react/

const schema = {
  carts: {
    type: 'carts',
    relationships: {
      'line-items': {
        type: 'line_items',
      },
      'merge-request': {
        type: 'merge_requests',
      },
    },
  },
  'line-items': {
    type: 'line_items',
  },
  purchases: {
    type: 'purchases',
  },
};

// reduce nesting to a reasonable level
const flattenData = (theObject) => {
  for (const prop in theObject) {
    if (theObject.hasOwnProperty(prop) && theObject[prop] instanceof Object && prop !== 'data') {
      flattenData(theObject[prop]);
    }

    if (theObject.data && !Array.isArray(theObject.data)) {
      Object.assign(theObject, { ...theObject.data });
      delete theObject.data;
    }
  }
};

const client = new ApiClient({
  url: process.env.REACT_APP_API_HOST,
  fetchOptions: { credentials: 'include' },
  schema,
  normalize: (data, _) => {
    const result = deserialize(data);
    result.data && flattenData(result.data);
    return result;
  },
});

export const JsonApiProvider = (props) => (
  <ApiProvider client={client}>{props.children}</ApiProvider>
);
